import { format, parseISO } from 'date-fns';

export function formatLocalDate(dateString?: string, showHour = false) {
  if (!dateString) {
    return '';
  }

  const fixedString = dateString.replace(/\+0000$/, 'Z');

  const date = new Date(fixedString);

  if (isNaN(date.getTime())) {
    return '';
  }

  if (showHour) {
    return date.toLocaleString('es-ES', {
      dateStyle: 'short',
      timeStyle: 'medium',
    });
  }

  return date.toLocaleString('es-ES', {
    dateStyle: 'short',
  });
}

export function getDuration(
  startAt: string,
  endAt: string
): { days: number; hours: number; minutes: number; seconds: number } {
  const start = new Date(startAt);
  const end = new Date(endAt);
  let delta = end.getTime() - start.getTime();

  const days = Math.floor(delta / (24 * 60 * 60 * 1000));
  delta -= days * 24 * 60 * 60 * 1000;

  const hours = Math.floor(delta / (60 * 60 * 1000));
  delta -= hours * 60 * 60 * 1000;

  const minutes = Math.floor(delta / (60 * 1000));
  delta -= minutes * 60 * 1000;

  const seconds = Math.floor(delta / 1000);

  return { days, hours, minutes, seconds };
}

export const formatDate = (dateStr?: string) => {
  if (!dateStr) return '';
  try {
    const fixed = dateStr.replace(/\+0000$/, 'Z');
    const parsed = parseISO(fixed);
    return format(parsed, 'dd MMM yyyy, hh:mma');
  } catch {
    return dateStr;
  }
};

export const formatDuration = (startAt: string, endAt?: string): string => {
  if (!startAt) return '0 minutos';

  const end = endAt || new Date().toISOString();
  const { days, hours, minutes } = getDuration(startAt, end);

  const parts: string[] = [];
  if (days > 0) parts.push(`${days} día${days > 1 ? 's' : ''}`);
  if (hours > 0) parts.push(`${hours} hora${hours > 1 ? 's' : ''}`);
  if (minutes > 0 && days === 0)
    parts.push(`${minutes} min${minutes > 1 ? 's' : ''}`);

  return parts.length > 0 ? parts.join(', ') : '0 minutos';
};
